/*
 * PokeVault PH — enforce inventory at add-to-cart everywhere the AJAX cart is used
 * (product page AND the collection "Choose options" quick-add modal).
 * Shopify's /cart/add.js does NOT block over-ordering (only checkout and
 * /cart/change.js do), so this caps the add to the variant's available stock
 * (accounting for what's already in the cart) and shows a message.
 * Stock comes from a per-variant map rendered on <product-info> as a
 * <script type="application/json" data-pv-stockmap> (tracked+deny variants;
 * value -1 = unlimited/untracked → skip). Loaded globally, so it also catches
 * the quick-add modal, whose injected product-info carries its own map.
 */
(function () {
  if (window.__pvStockcap) return; // guard against double-load
  window.__pvStockcap = true;

  var FORM_SEL = 'form[data-type="add-to-cart-form"]';
  var cartMap = {};

  function containerOf(form) {
    return form.closest('product-info') || form.closest('quick-add-modal') || document;
  }
  function qtyInputFor(form) {
    // Only use a quantity input that truly belongs to this form (product page /
    // quick-add modal). Single-variant card "+ Add" has none -> return null (qty 1).
    var c = form.closest('product-info') || form.closest('quick-add-modal');
    if (c) return c.querySelector('.quantity__input[name="quantity"]');
    return document.querySelector('.quantity__input[name="quantity"][form="' + form.id + '"]');
  }
  function variantId(form) {
    var el = form.querySelector('[name="id"]');
    return el ? el.value : null;
  }
  function stockFor(form, vid, qi) {
    // 1) single-value stock stamped on the form (single-variant card "+ Add")
    var pf = form.closest('product-form');
    if (pf && pf.hasAttribute('data-pv-stock')) {
      var s = parseInt(pf.getAttribute('data-pv-stock'), 10);
      if (!isNaN(s)) return s;
    }
    // 2) per-variant map on product-info (product page / quick-add modal)
    var c = containerOf(form);
    var el =
      c.querySelector('script[type="application/json"][data-pv-stockmap]') ||
      document.querySelector('script[type="application/json"][data-pv-stockmap]');
    if (el && vid != null) {
      try {
        var map = JSON.parse(el.textContent) || {};
        if (map[String(vid)] != null) return parseInt(map[String(vid)], 10);
      } catch (e) {}
    }
    // 3) fallback: attribute on the quantity input
    return qi ? parseInt(qi.getAttribute('data-pv-stock'), 10) : -1;
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartMap = {};
        (c.items || []).forEach(function (i) { cartMap[String(i.variant_id)] = i.quantity; });
      })
      .catch(function () {});
  }
  function showError(form, msg) {
    var pf = form.closest('product-form');
    if (pf) {
      var wrap = pf.querySelector('.product-form__error-message-wrapper');
      var span = pf.querySelector('.product-form__error-message');
      if (wrap && span) { span.textContent = msg; wrap.removeAttribute('hidden'); return; }
      // fallback for the card "+ Add" form (no built-in error element): inline note
      var note = pf.querySelector('.pv-stock-note');
      if (!note) {
        note = document.createElement('div');
        note.className = 'pv-stock-note';
        note.setAttribute('role', 'alert');
        note.style.cssText = 'margin-top:.6rem;font-size:1.2rem;line-height:1.3;color:#b3261e;text-align:center;';
        pf.appendChild(note);
      }
      note.textContent = msg;
      note.hidden = false;
      clearTimeout(note._t);
      note._t = setTimeout(function () { note.hidden = true; }, 4000);
      return;
    }
    window.alert(msg);
  }
  function clearError(form) {
    var pf = form.closest('product-form');
    if (pf) {
      var wrap = pf.querySelector('.product-form__error-message-wrapper');
      if (wrap) wrap.setAttribute('hidden', '');
    }
  }
  function onSubmit(e) {
    var form = e.target.closest(FORM_SEL);
    if (!form) return;
    var qi = qtyInputFor(form);
    var vid = variantId(form);
    var stock = stockFor(form, vid, qi);
    if (isNaN(stock) || stock < 0) return; // untracked / oversell allowed
    var inCart = (vid && cartMap[String(vid)] != null)
      ? cartMap[String(vid)]
      : (qi ? parseInt(qi.getAttribute('data-cart-quantity') || '0', 10) : 0);
    if (isNaN(inCart)) inCart = 0;
    var req = qi ? parseInt(qi.value || '1', 10) : 1;
    if (isNaN(req) || req < 1) req = 1;
    if (inCart + req > stock) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var allowed = Math.max(0, stock - inCart);
      if (qi) {
        var minv = parseInt(qi.getAttribute('min') || '1', 10);
        qi.value = String(Math.max(minv, allowed));
      }
      var msg;
      if (allowed <= 0) {
        if (inCart >= stock) {
          msg = stock === 1
            ? "That's the only one in stock — it's already in your cart."
            : 'You already have all ' + stock + ' in your cart.';
        } else {
          msg = 'Only ' + stock + ' in stock.';
        }
      } else if (inCart > 0) {
        msg = 'Only ' + stock + ' in stock — you have ' + inCart + ' in your cart, so you can add ' + allowed + ' more.';
      } else {
        msg = 'Only ' + stock + ' in stock, so you can add up to ' + allowed + '.';
      }
      showError(form, msg);
    } else {
      // allowed: optimistically track so rapid repeat clicks stay accurate
      if (vid) cartMap[String(vid)] = inCart + req;
      clearError(form);
    }
  }

  document.addEventListener('submit', onSubmit, true); // capture: run before product-form.js
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCart);
  } else {
    refreshCart();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"]')) setTimeout(refreshCart, 1200);
  }, true);
})();
